<template>
  <div v-if="state.isShow" class="add-main">
    <Header :config="headConfig" />
    <div>
      <div class="add-main-select">
        <SelectStore :config="storeConfig" :disabled="disabled" @selectApp="selectStore" :is-ipad="false" />
        <van-cell title="Country/Region" is-link @click="selectCoutry">
          <template #value>
            <p v-if="!form.region">Click Add Country</p>
            <div v-else class="country-right">
              <Region :region="form.region" />
            </div>
          </template>
        </van-cell>
      </div>
      <van-search 
        v-model="searchVal"
        placeholder="Add an App" 
        show-action
        @search="onSearch"
      >
        <template #action>
          <div class="search" @click="onSearch">Search</div>
        </template>
      </van-search>
      <div class="add-app-main">
        <div v-if="searchClick ">
          <div class="search-list">
            <div v-if="serchData.length===0">
              <NullData />
            </div>
            <van-list v-else v-model="loading">
              <div v-for="item in serchData" :key="item.id" class="li flex align-center" @click="handleApp(item)">
                <img v-if="form.platform===1" class="margin-right" :src="google">
                <img v-else-if="form.platform===2" class="margin-right" :src="ios">
                <img v-else class="margin-right" :src="google">
                <img :src="item.icon">
                <div class="right">
                  <p class="artist"> {{ item.name }}</p>
                  <p class="introduce artist"> {{ item.artist }}</p>
                </div>
              </div>
            </van-list>
          </div>
        </div>
        <div v-else>
          <p class="desc text-sm">Add an App by entering an App name or App ID
            ie: 568939854 or com.facebook.katana</p>
          <div class="app-notice text-sm">
            <p class="title">
              Notice:
            </p>
            <ul>
              <li>
                * App should be FREE (we can't promote paid apps).
              </li>
              <li>
                * App should be available in selected country for large number of devices.
              </li>
              <li>
                * App doesn't require any special system permissions (like Root or NFC) .
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Loading :loading="loading" :top="217" />
    </div>
    <transition name="slide">
      <SelectCountry ref="contryRef" :platform="form.platform" @getCountry="chanegCoutry" />
    </transition>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, ref,toRefs, reactive,onBeforeMount,computed,watch } from 'vue';
import { post } from 'src/utils/request.js';
import event from 'utils/eventBus';
import Region from 'components/Region'
import Loading from 'components/Loading'
import google from 'assets/images/icon/icon-google.svg'
import ios from 'assets/images/icon/icon-apple.svg'
import { Toast } from 'vant';
export default {
  name: 'AddApp',
  components:{
    Region,
    Loading
  },
  props:{
    platform:{
      type:Number,
      default:1
    },
    region:{
      type:String,
      default:'US'
    },
    //是否需要调用addApp接口
    addApp:{
      type:Boolean,
      default:true
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },
  emits:['addSuccess', 'addApp'],
  setup(props,crx) {
    const headConfig = {
      callBackName:'choseBack',
      type: 'other',
      title: 'Add New App',
    };
    const data=reactive({
      loading: false
    })
    const instance = getCurrentInstance();
    const api = instance.appContext.config.globalProperties.$url;
    const searchClick = ref(false);
    const form = reactive({
      platform: props.platform?props.platform:1,
      region:props.region,
    });
    const searchVal=ref(null)
    const state = reactive({
      isShow:false
    });
    const serchData = ref([]);
    const contryRef = ref(null)
    const storeConfig=computed(()=>{
      return{
        active:props.platform?props.platform:1,
        eventName: 'selectApp'
      }
    })
    const onSearch = async() => {
      if(!searchVal.value.trim()){
        searchClick.value = false;
      }else{
        searchClick.value = true;
        serchData.value = []
        data.loading = true
        const res = await post(api.HOME_SEARCH_APP, {
          ...form,
          page: 0,
          pageSize: 300,
          word: searchVal.value
        });
        data.loading = false
        if(res.code === 0){
          serchData.value = res.data.list;
        }
      }
      
      
    };
    //点击list列表 添加 app
    const handleApp = async (item) => {
      if(props.addApp) {
        data.loading = true
          
        const res = await post(api.POST_ADDAPP, {
          platform:form.platform,
          region:form.region,
          appId:item.id
        })
        if(res && res.code === -1) {
          Toast({
              message: res.msg,
              position: 'top',
          });
        }
        data.loading = false
      }
      state.isShow = false
      crx.emit('addSuccess',form.platform)
      crx.emit('addApp',item)
    };
    // 获取store
    const selectStore=(val)=>{
      form.platform=val
      onSearch()
    }
    //选择国家
    const selectCoutry = ()=>{
      if(!props.disabled) {
        contryRef.value.openBox()
      }
    }
    // 获取选择的国家
    const chanegCoutry = (val) =>{
      form.region = val.sign
      onSearch()
    }
    // 打开选择app
    const openAppBox= () => {
      form.region="US"
      searchClick.value = false
      serchData.value = []
      searchVal.value=""
      data.loading=false
      state.isShow = true
    };
    watch(()=>props.platform,(val)=>{
      form.platform=val
    })
    onMounted(() => {
      event.$on('choseBack', () => {
        state.isShow = false
      });
    });
    onBeforeMount(() => {
      event.$off('choseBack')
    });
    return { searchClick,
      contryRef,
      serchData,
      post,
      onSearch,selectCoutry,
      handleApp,
      headConfig,
      selectStore,
      chanegCoutry,
      state,
      openAppBox,
      searchVal,
      ...toRefs(form),
      ...toRefs(data),
      form,
      google,ios,
      storeConfig,
      ...toRefs(props)

    }
  }
};
</script>

<style scoped  lang="scss">

.add-main {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 10001;
  background: #f6f5ff;

  .add-main-select {
    background: #fff;
    margin: 8px 0;
    color: red;
  }

  :deep(.van-cell__title),
  :deep(.van-cell__value) {
    flex: auto;
  }
}

.add-app-main {
  background: #fff;
  height: calc(100vh - 225px);
  position: relative;

  & > div {
    height: 100%;
    overflow: auto;
    padding: 0 10px;
  }

  .desc {
    color: $desc;
    line-height: 20px;
    padding-top: 17px;
  }

  .app-notice {
    margin-top: 23px;

    .title {
      line-height: 20px;
    }

    ul {
      color: $desc;
      line-height: 20px;
      margin-bottom: 10px;
    }
  }

  .search-list {
    padding: 0 10px;

    img {
      width: 31px;
      height: 30px;
      border-radius: 15%;

      &:nth-child(1) {
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }
    }

    .li {
      height: 46px;
      margin-top: 2px;

      .right {
        margin-left: 2px;

        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 200px;
        }

        .artist {
          line-height: 14px;
          color: $fontColor;
        }

        .introduce {
          color: #a5a3b2;
        }
      }
    }
  }
}

.search {
  height: 34px;
  background: #1c82f4;
  color: #fff;
  border-radius: 3px;
  font-size: 13px;
  padding: 0 5px;
}

:deep(.add-main-select .van-cell__title) {
  font-weight: bold !important;
}
</style>
